import { toast } from "react-toastify";

export async function getUserLocation() {
  if (!navigator.geolocation) {
    toast.error("Location permission is required to login");
    return null;
  }

  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        if (latitude == null || longitude == null) {
          toast.error("Location permission is required to login");
          resolve(null);
          return;
        }

        resolve({ latitude, longitude });
      },
      (error) => {
        console.error("Geolocation error:", error);
        toast.error("Location permission is required to login");
        resolve(null);
      },
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0,
      }
    );
  });
}
